import TaskPage from './TaskPage';

export default TaskPage;
